<template>
	<div id="app">
		<Navbar v-if="$route.meta.nav"></Navbar>
		<Head v-if="$route.meta.nav"></Head>
		<keep-alive>
			<router-view v-if="!$route.meta.nokeep" />
		</keep-alive>
		<transition name="fade" mode="out-in">
			<router-view v-if="$route.meta.nokeep" />
		</transition>
		<foot v-if="!$route.meta.foots"></foot>
		<!-- 全局加载指示器 -->
		<div class="global-loading" v-if="isLoading">
			<div class="loading-content">
				<div class="loading-spinner"></div>
				<div class="loading-text">加载中...</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	export default {
		name: "App",
		components: {

		},
		data() {
			return {
				isLoading: false
			}
		},
		created() {
			// 初始化语言设置
			const lang = localStorage.getItem("lang") || "ch";
			this.$i18n.locale = lang;
			this.$store.commit("changeLanguage", lang);
			
			// 创建事件总线监听加载状态
			this.$root.$on('loading-start', () => {
				this.isLoading = true;
			});
			this.$root.$on('loading-end', () => {
				this.isLoading = false;
			});
			
			// 添加路由切换前的钩子
			this.$router.beforeEach((to, from, next) => {
				// 如果是从模考页面到试题页面的跳转
				if (from.path === '/package_test' && to.path === '/courseInfo') {
					this.isLoading = true;
				}
				next();
			});
			
			// 添加路由切换后的钩子
			this.$router.afterEach(() => {
				// 路由切换完成后关闭加载状态
				setTimeout(() => {
					this.isLoading = false;
				}, 500); // 延迟关闭以确保新页面已加载
			});
		},
		mounted() {

		},
		watch: {

		},
		methods: {

		}
	};
</script>

<style lang="less">
	@import url('~@/assets/font/font.less');
	
	/* 路由过渡动画 */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.3s;
	}
	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}
	
	/* 全局加载样式 */
	.global-loading {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(255, 255, 255, 0.9);
		z-index: 9999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.loading-content {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	
	.loading-text {
		margin-top: 15px;
		color: #1991BF;
		font-size: 16px;
		font-weight: bold;
	}
	
	.loading-spinner {
		width: 50px;
		height: 50px;
		border: 5px solid #f3f3f3;
		border-top: 5px solid #1991BF;
		border-radius: 50%;
		animation: spin 1s linear infinite;
	}
	
	@keyframes spin {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(360deg); }
	}
</style>


// WEBPACK FOOTER //
// src/App.vue